import React, { useEffect } from 'react';
import { Card, Icon } from 'components';
import BRpdf from './BR-2022-065.pdf'

const Contact = () => {

  useEffect(() => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }, [])
  return (
    <Card>
      <Card.Header>
        <b>How To's and Guidelines</b>
      </Card.Header>
      <Card.Body>
        <div className="flex flex-col xl:flex-row lg:flex-row -mt-5">
          <div className="flex-1 p-5 ">
            <b className="text-primary">Procedure on how to get an appointment date/slot:</b>
            <ol className="flex-col space-y-5 my-5">
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  1.
                </span>
                <span>Create an account and fill out the fields provided by the system with <span className="text-red-600">complete details</span> and <span className="text-red-600">information</span>;</span>
              </li>
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  2.
                </span>
                <span>List of Requirements and Appointment date for the personal filing of the application at LTFRB Central Office will be provided to the applicant via the online system.</span>
              </li>
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  3.
                </span>
                <span>A confirmation text message will be sent to the applicant once the appointment is successful.</span>
              </li>
            </ol>
            <p><b>Guidelines</b></p>
            <ol className="flex-col space-y-5 my-5">
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  1.
                </span>
                <span>APPLICANT MUST ENSURE ALL DETAILS AND INFORMATION BE DULY FILLED OUT VIA THE ONLINE SYSTEM.  APPLICANT IS ADVICED TO BRING ALL THE NECESSARY DOCUMENTARY REQUIREMENTS INITIALLY REQUIRED DURING THE FILING OF THE APPLICATION ON THE APPOINTMENT DATE;</span>
              </li>
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  2.
                </span>
                <span>
                  APPLICANT MUST PERSONALLY FILE THE APPLICATION AT LTFRB CENTRAL OFFICE. IF THE APPLICANT IS NOT AVAILABLE, SPOUSE OR THE DIRECT ASCENDANT/DECENDANT IS ALLOWED PROVIDED A SPECIAL POWER OF ATTORNEY IS PRESENTED TOGETHER WITH ORIGINAL COPY OF A GOVERNMENT VALID ISSUED ID OF THE APPLICANT AND ATTORNEY-IN-FACT.
                  A LAWYER IS ALLOWED TO PERSONALLY FILE THE APPLICATION ON BEHALF OF APPLICANT WITH HIS ENTRY OF APPEARANCE. SAID LAWYER MAY NOT FURTHER DELEGATE THE ACTUAL FILING OF THE APPLICATION TO HIS/HER REPRESENTATIVE;
                </span>
              </li>
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  3.
                </span>
                <span>APPLICANT SHALL SUBMIT THE INITIAL REQUIREMENTS UPON THE FILING OF THE APPLICATION, TO WIT;</span>
              </li>
              <ul className="flex-col space-y-5 my-5 ml-8">
                <li className="flex space-x-3">
                  <span className="h-5 flex">
                    A.
                  </span>
                  <span >Four (4) original copies of Verified Application. (the template can be printed in the system or can be downloaded at <a href={"https://ltfrb.gov.ph/"} target="blank" className="text-blue-600">www.ltfrb.gov.ph</a>)</span>
                </li>
                <li className="flex space-x-3">
                  <span className="h-5 flex">
                    B.
                  </span>
                  <span >Photocopy of Official Receipt and Certificate of Registration (OR/CR). <b>If the unit is encumbered, only those with Certificate of Conformity from the mortgagee bank or financial institution (as mentioned under item no. 3) shall be accepted.</b></span>
                </li>
                <li className="flex space-x-3">
                  <span className="h-5 flex">
                    C.
                  </span>
                  <span >Proof of Filipino Citizenship, such as Birth Certificate, Passport, Voter’s ID or any valid Government-issued Identification Card showing Citizenship.</span>
                </li>
              </ul>
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  4.
                </span>
                <span>UNIT SUBJECT OF THE APPLICATION MUST NOT BE MORE THAN THREE (3) YEARS OLD;</span>
              </li>
              {/* <li className="flex space-x-3">
                <span className="h-5 flex">
                  5.
                </span>
                <span>FAILURE OF APPLICANT TO FILE HIS/HER APPLICATION DURING THE APPOINTMENT DATE SHALL CAUSE THE FORFEITURE OF HIS/HER SLOT.</span>
              </li> */}
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  5.
                </span>
                <span><span className="text-red-600">PROVISIONAL AUTHORITY</span> WILL BE ISSUED TO APPLICANTS WITH COMPLETE INITIAL REQUIREMENT UPON SUBMISSION OF;</span>
              </li>
              <ul className="flex-col space-y-5 my-5 ml-8 text-red-600">
                <li className="flex space-x-3">
                  <span className="h-5 flex">
                    a.
                  </span>
                  <span >Personal Passenger Accident Insurance</span>
                </li>
              </ul>
              <li className="flex space-x-3">
                <span className="h-5 flex">
                  6.
                </span>
                <span>UPON ISSUANCE OF THE PA, APPLICANT IS DIRECTED TO PROCEED TO THE TRANSPORT NETWORK COMPANY (TNC) OF THEIR CHOICE FOR ACCREDITATION.</span>
              </li>
            </ol>
            <p><b>FOR YOUR GUIDANCE,</b></p>
            <br />
            <p className="italic">For detailed information and guidelines please download <a href={BRpdf} className="text-blue-600 font-bold italic" download="BR-2022-065.pdf">here</a>. Board Resolution No. 065. Series of 2022.</p>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}


export default Contact